module.exports = __webpack_public_path__ + "static/media/test project10-6-2021-SRT_test_by_Dev_1634590800716.29c2eca7.vtt";